import { render, staticRenderFns } from "./telemedicina_consulta.vue?vue&type=template&id=21f87269&"
import script from "./telemedicina_consulta.vue?vue&type=script&lang=js&"
export * from "./telemedicina_consulta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VDataTable,VSelect})
